<template>
  <v-dialog v-model="modal" :width="modalSize">
    <v-bottom-navigation height="100px">
      <v-btn @click="downloadLink">
        <img src="resources/images/download.svg" height="78px" />
      </v-btn>
      <v-btn @click="orthancLink" v-if="orthancActive">
        <img src="resources/images/orthanc.png" height="75px" />
      </v-btn>
      <v-btn @click="ohifLink" v-if="ohifActive">
        <img src="resources/images/ohif.svg" height="75px" />
      </v-btn>
    </v-bottom-navigation>
  </v-dialog>
</template>

<script>
import i18n from "../../../i18n";
import EventBus from "../../../event-bus";

export default {
  name: "ViewModal",
  props: {
    studyData: Object,
    dicomViewers: Object,
  },
  computed: {
    orthancActive: function () {
      if (this.dicomViewers == null || this.dicomViewers.viewers == null) {
        return false;
      } else {
        return this.dicomViewers.viewers.orthancActive;
      }
    },
    ohifActive: function () {
      if (this.dicomViewers == null || this.dicomViewers.viewers == null) {
        return false;
      } else {
        return this.dicomViewers.viewers.ohifActive;
      }
    },
    modalSize: function () {
      const WIDTH = 105;
      let size = 0;
      size = WIDTH;

      if (this.dicomViewers != null && this.dicomViewers.viewers.orthancActive)
        size += WIDTH;
      if (this.dicomViewers != null && this.dicomViewers.viewers.ohifActive)
        size += WIDTH;

      return size;
    },
  },
  data: () => ({
    modal: false,
    study: "",
  }),
  watch: {
    studyData: function (value) {
      this.study = value.data;
      this.modal = true;
    },
    modal: function (value) {
      if (this.link && !value) {
        // Wait for modal to hide
        setTimeout(() => {
          window.open(this.link);
          this.link = null;
        }, 200);
      }
    },
  },
  methods: {
    downloadLink() {
      let link =
        window.location.href + "api/v1/dicom/zip/" + this.study.studyDbId;
      navigator.clipboard.writeText(link);
      EventBus.$emit("SHOW_SNACKBAR", i18n.t("Copied to clipboard!"), 1000);
      this.modal = false;
    },
    ohifLink() {
      let studyIuid = this.study.studyIuid;

      // Fix OHIF error
      if (studyIuid.indexOf(".") === -1) {
        studyIuid += "..";
      }

      let link = window.location.href + "viewer/" + studyIuid;
      navigator.clipboard.writeText(link);
      EventBus.$emit("SHOW_SNACKBAR", i18n.t("Copied to clipboard!"), 1000);
      this.modal = false;
    },
    orthancLink() {
      let link =
        this.dicomViewers.viewers.orthancUrl +
        "/index.html?study=" +
        this.study.studyIuid;
      navigator.clipboard.writeText(link);
      EventBus.$emit("SHOW_SNACKBAR", i18n.t("Copied to clipboard!"), 1000);
      this.modal = false;
    },
  },
};
</script>

<style scoped>
.v-dialog {
  bottom: 10px !important;
  right: 0 !important;
}
</style>
